var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllocated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20968_177843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
    fill: "url(#paint0_linear_20968_177843)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7749 13.575L15.0124 9.3375C15.1124 9.2375 15.2311 9.1875 15.3686 9.1875C15.5061 9.1875 15.6249 9.2375 15.7249 9.3375C15.8249 9.4375 15.8749 9.55625 15.8749 9.69375C15.8749 9.83125 15.8249 9.95 15.7249 10.05L11.1249 14.65C11.0249 14.75 10.9082 14.8 10.7749 14.8C10.6415 14.8 10.5249 14.75 10.4249 14.65L8.27486 12.5C8.17486 12.4 8.12694 12.2812 8.13111 12.1437C8.13528 12.0063 8.18736 11.8875 8.28736 11.7875C8.38736 11.6875 8.50611 11.6375 8.64361 11.6375C8.78111 11.6375 8.89986 11.6875 8.99986 11.7875L10.7749 13.575Z",
    fill: "#F7F7F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20968_177843",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E7D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF598"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20968_177843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllocated);
export default __webpack_public_path__ + "static/media/allocated.98b1c6e04c07ae99d4ab4935dc35d39b.svg";
export { ForwardRef as ReactComponent };